import {RequiredFieldsNote} from "@/components/form/requiredFieldsNote/RequiredFieldsNote.tsx";
import {FormContentContainer} from "@/components/layout/FormContentContainer.tsx";
import {ITabContentLayoutProps} from "@/components/layout/TabContentContainer.types.ts";
import {NavTabs} from "@/components/navTabs/NavTabs.tsx";

import styles from "./FormContentContainer.module.scss";

export const TabContentContainer = ({
  sections,
  title,
  actionsBar,
  children,
  tab,
  setTab,
  className,
  headerClassName,
  variant = "primary",
  tabContentClassName,
  hasRequiredFields = false,
}: ITabContentLayoutProps) => {
  return (
    <FormContentContainer
      title={title}
      actionsBar={actionsBar}
      className={className}
      variant={variant}
      tabContentClassName={tabContentClassName}
      headerContent={
        <NavTabs
          items={Object.values(sections).filter((s) => s.isVisible ?? true)}
          selectedId={sections[tab].id}
          className={styles.tabTitles}
          selectTab={(tabName) => {
            setTab(tabName);
          }}
        />
      }
      headerClassName={headerClassName}
    >
      {hasRequiredFields && <RequiredFieldsNote />}
      {children}
    </FormContentContainer>
  );
};
